// Packages
import { Routes, Route } from "react-router-dom"

// Screens
import BookingListScreen from "modules/Bookings/screens/List"
import BookingViewScreen from "modules/Bookings/screens/View"
import BookingCreateScreen from "modules/Bookings/screens/Create"
import BookingEditScreen from "modules/Bookings/screens/Edit"
import ExpiredBookingListScreen from "../screens/Expired"



const BookingRoutes = () => 
{
	return (
		<Routes>
			<Route path="/*" element={<BookingListScreen />}/>
			<Route path="/expired/*" element={<ExpiredBookingListScreen />}/>
			<Route path="/create/*" element={<BookingCreateScreen />}/>
			<Route path="/:orderId/edit/*" element={<BookingEditScreen />}/>
			<Route path="/:orderId/*" element={<BookingViewScreen />}/>
		</Routes>
	)
}

export default BookingRoutes;